import React from 'react'
import { ModalTypes } from '@/types'
import { Dialog } from '@headlessui/react'
import { ModalWrapper, ModalContentWrapper, ModalTitle, ModalBackdrop, ModalDescription } from './Modal.styles'
import { Heading, Icon } from '@big-red-group/storefront-common-ui'

type ModalProps = {
  title?: string
  description?: string
  children: React.ReactNode
  onClose: () => void
  isOpen: boolean
  width?: string
  maxWidth?: string
  height?: string
  dataTestId?: string
  showCloseIcon?: boolean
  fullScreenMobile?: boolean
  type?: ModalTypes
  intialFocus?: React.RefObject<HTMLInputElement>
}

const Modal: React.FC<ModalProps> = ({
  title,
  description,
  children,
  onClose,
  isOpen,
  width,
  maxWidth,
  height,
  dataTestId,
  showCloseIcon = false,
  fullScreenMobile = false,
  type = 'generic',
  intialFocus,
}) => {
  return (
    <Dialog initialFocus={intialFocus} open={isOpen} onClose={onClose} data-testid={dataTestId}>
      <ModalBackdrop type={type}>
        <ModalWrapper
          type={type}
          className={fullScreenMobile ? 'fullscreen-mobile' : ''}
          width={width}
          maxwidth={maxWidth}
          height={height}
        >
          {title && (
            <ModalTitle>
              <Heading size="XS" customMobileSize="M" spacing={false} style={{ color: "white" }}>
                {title}
              </Heading>
              {showCloseIcon && <Icon name="close" onClick={onClose} viewBox="0 0 24 24" />}
            </ModalTitle>
          )}
          {description && <ModalDescription>{description}</ModalDescription>}
          <ModalContentWrapper>{children}</ModalContentWrapper>
        </ModalWrapper>
      </ModalBackdrop>
    </Dialog>
  )
}

export default Modal
